export const PAYMENT_METHOD_OPTIONS = [
  {
    label: "Cash",
    value: "Cash"
  },
  {
    label: "Credit Card",
    value: "CreditCard"
  },
  {
    label: "Mobile Money",
    value: "MobileMoney"
  }
];
